import styled from "../../theme";
import { WrapperMain } from "src/theme/objects/Layout";

export const Wrapper = styled(WrapperMain)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: ${(p) => p.theme.colors.colorGray()};
  position: relative;
  font-size: ${(p) => p.theme.fonts.h2};
  font-weight: ${(p) => p.theme.fonts.fontLight};
`;

export const ErrorStatus = styled.div`
  color: ${(p) => p.theme.colors.colorAlert()};
  font-size: 500px;
  margin-bottom: ${(p) => p.theme.spacing.defaultSpacing(14)};
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
  top: calc(50% - 20px);
  opacity: 0.3;
`;
